{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Näytä kaikki vaihtoehdot",
  "Spoiler_Reveal_Tooltip": "Klikkaa näyttääksesi",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Twiittaa tämä",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Kohde on kutistettu",
  "Spoiler_Reveal_Video_CTA": "Näytä video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Laajenna kuva",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Näytä kaikki tulokset",
  "Spoiler_Reveal_Image_Placeholder": "Tämä kuva sisältää spoilerin",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Hakusäädin",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Voit äänestää useamman kuin yhden vastauksen puolesta.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Näytä lisää ääniohjauksia",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Sulje",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Ladataan {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Lue lisää",
  "Spoiler_Insert_Tooltip": "Spoileri",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Äänenvoimakkuus",
  "Spoiler_Reveal_Gallery_Placeholder": "Tämä galleria sisältää spoilerin",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Varaa nyt",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Poista mykistys",
  "Spoiler_Reveal_Gallery_CTA": "Näytä galleria",
  "Poll_Viewer_ShowLess_CTA": "Näytä vähemmän",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Mykistä",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} tuntematonta",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Seuraa",
  "VerticalEmbed_Products_Button": "Osta nyt",
  "Poll_Viewer_Toast_Error_ServerDown": "Palvelimeen ei saatu yhteyttä. Yritä myöhemmin uudelleen.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} henkilöä äänesti tämän vastauksen puolesta",
  "Poll_Viewer_VoteCount": "{{number}} ääntä",
  "VerticalEmbed_Events_Button": "Rekisteröidy nyt",
  "Spoiler_Reveal_Image_CTA": "Näytä kuva",
  "Poll_Viewer_Toast_Error_Connection": "Ei internet-yhteyttä. Tarkista yhteytesi.",
  "Poll_Viewer_Visibility_Owner_Footer": "Vain sinä voit nähdä tulokset.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} ihmistä äänesti tämän vastauksen puolesta",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Kohde on laajennettu",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Tämä video sisältää spoilerin",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Näytä koko päivitys",
  "UploadFile_Viewer_Download": "Lataa {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} t",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
